import { useState } from 'preact/hooks';
import { useDispatch } from 'react-redux';

import { Button } from '@/components/Buttons';
import PersonaSelector from '@/components/PersonaSelector';

import { personaCopy } from '../copy';
import speedyFlowSlice from '../redux/slice';
import { Persona } from '../types';

const { advanceSpeedyFlow } = speedyFlowSlice.actions;

/**
 * The opening step of the Sign-In Flow, which doubles as the route choice: pick what brings you
 * here, then either sign up or say you already have an account.
 *
 * Choosing a persona does not advance — it is recorded and the visitor still has to pick a route.
 * There is deliberately no skip control; someone who does not want to answer dismisses the modal.
 */
const PersonaStep = () => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState<Persona | null>(null);

  const choose = (persona: Persona) => {
    setSelected(persona);
    dispatch(advanceSpeedyFlow({ type: 'chosePersona', persona }));
  };

  return (
    <div className="flex flex-col gap-6 p-6" data-component="speedy-step" data-step="persona">
      <div>
        <h2 className="preflight preflight-h2 text-center text-2xl/7 font-bold text-forest-dark">{personaCopy.title}</h2>
        <p className="preflight preflight-p mt-2 text-center text-sm text-grey-3">{personaCopy.subtitle}</p>
      </div>

      <PersonaSelector value={selected} onChange={choose} className="flex flex-col gap-2" />

      <div className="flex flex-col gap-2">
        <Button size="lg" onClick={() => dispatch(advanceSpeedyFlow({ type: 'choseSignUp' }))}>
          {personaCopy.signUp}
        </Button>
        <Button variant="outline" size="lg" onClick={() => dispatch(advanceSpeedyFlow({ type: 'choseLogIn' }))}>
          {personaCopy.logIn}
        </Button>
      </div>
    </div>
  );
};

export default PersonaStep;
